import { Module } from "wrapper6";
import ImageCompare from "image-compare-viewer";

export default class ExplicitContent extends Module {

  ready(app) {
    jQuery(document).on('click', '.mtt-before-after-image-widget__blurred-image-container .mtt-before-after-image-widget__blurred-wrapper', (e) => {
      e.preventDefault()

      const imageContainers = jQuery('.mtt-before-after-image-widget__image-container')
      const explicitContainers = jQuery('.mtt-before-after-image-widget__blurred-image-container')

      imageContainers.removeClass('mtt-before-after-image-widget__image-container--hide')
      explicitContainers.remove()

      const d = new Date()
      d.setTime(d.getTime() + 86400000) // 1 day
      const expires = "expires="+d.toUTCString()
      document.cookie = 'show_explicit' + "=" + 1 + ";" + expires + ";path=/"
    })
  }
}